import { useITwinEventsServiceV1API } from "../useITwinEventsServiceV1API/useITwinEventsServiceV1API";

export const useConsumerController = <T,>(cacheResponse: boolean = true) => {
  return useITwinEventsServiceV1API<T>("consumers", cacheResponse);
};
